module.exports = __webpack_public_path__ + "static/media/Deconstructed.0a2c8e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/Deconstructed.png
// module id = 338
// module chunks = 0